import {Component, OnInit, ViewChild} from '@angular/core';
import {BankTransferLoadService} from '../../../bank-transfer-load.service';
import {BankTransferRefundService} from '../../services/bank-transfer-refund.service';
import {MatTableGeneratorComponent} from '../../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {BankTransferLoad} from '../../../dto/bankTransferLoad';
import {toDateTimeString} from '../../../providers/app-date-adapter';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from '../../../services/role.service';
import {Location} from '@angular/common';
import {AppMatCustomAction} from '../../../shared/mat-table-generator/mat-table-core/app-mat-custom-action';
import {Card} from '../../../dto/card';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {ToastService} from 'angular-toastify';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-load-refunds',
  templateUrl: './load-refunds.component.html',
  styleUrls: ['./load-refunds.component.css']
})
export class LoadRefundsComponent implements OnInit {

  constructor(
    private bankTransferLoadService: BankTransferLoadService,
    private bankTransferRefundService: BankTransferRefundService,
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private location: Location,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private _toastService: ToastService,
  ) {

  }



  @ViewChild(MatTableGeneratorComponent, {static: true}) table: MatTableGeneratorComponent;
  dataSource = new MultiCrudDataSource(this.bankTransferRefundService);
  columns = [
    {columnDef: 'createDate', header: 'Created', cell: (row: BankTransferLoad) => `${toDateTimeString(row.createDate) || ''}`},
    {columnDef: 'loadType', header: 'Type', icon: (row: BankTransferLoad) => row.loadType == 1 ? 'account_balance' : 'assignment_ind', cell: (row: BankTransferLoad) => `${row.loadType == 1 ? 'Bank' : 'Partner'}`, cellColor: (row: BankTransferLoad) => `${row.loadType == 1 ? 'grey' : 'blue'}`},
    {columnDef: 'amount', header: 'Amount', cell: (row: BankTransferLoad) => `${row.amountToLoad.formatMoneyCcy(row.currencyCode)}`},
    {columnDef: 'loadFee', header: 'Fee', cell: (row: BankTransferLoad) => `${row.loadFee.formatMoneyCcy(row.currencyCode)}`},
    {columnDef: 'card', sortable: false, header: 'Card', cell: (row: BankTransferLoad) => `${(row.card != null ? row.card.token : '(no card)')}`},
    {columnDef: 'status', sortable: false, header: 'Status', cell: (row: BankTransferLoad) => false, icon: (row: BankTransferLoad) => {
        if (row.isApprovedAutomatically && !row.isApprovedManually && !row.isDeclinedManually) {
          return 'done';
        }
        if (row.isApprovedManually && !row.isDeclinedManually) {
          return 'done';
        }
        if (row.isDeclinedManually) {
          return 'clear';
        }
        if (row.needsManualApproval && !row.isApprovedManually && !row.isApprovedAutomatically && !row.isDeclinedManually) {
          return 'warning';
        }


      }, cellColor: (row: BankTransferLoad) => {
        if (row.isDeclinedManually) {
          return 'red';
        }
        if (row.isApprovedAutomatically && row.needsManualApproval && !row.isApprovedManually && !row.isDeclinedManually) {
          return 'dodgerblue';
        }
        if (row.isApprovedManually && !row.isDeclinedManually) {
          return 'forestgreen';
        }
        if (row.isApprovedAutomatically && !row.needsManualApproval) {
          return 'dodgerblue';
        }
        if (row.needsManualApproval && !row.isApprovedManually && !row.isApprovedAutomatically && !row.isDeclinedManually) {
          return 'orange';
        }
      }
    },
    {columnDef: 'statusText', sortable: false, header: '', cell: (row: BankTransferLoad) => {
        if (row.isDeclinedManually) {
          return 'Declined';
        }
        if (row.isApprovedAutomatically && row.needsManualApproval && !row.isApprovedManually && !row.isDeclinedManually) {
          return 'Pending';
        }
        if (row.isApprovedAutomatically && !row.needsManualApproval) {
          return 'Approved automatically';
        }
        if (row.isApprovedManually && !row.isDeclinedManually) {
          return 'Approved';
        }
        if (row.needsManualApproval && !row.isApprovedManually && !row.isApprovedAutomatically && !row.isDeclinedManually) {
          return 'Needs approval';
        }
      }},
    {cell: (row: BankTransferLoad) => false, columnDef: 'isExported', header: 'Exported', icon: (row: BankTransferLoad) => {
        if (row.isExported) {
          return 'file_download_done';
        }
        return 'hourglass_empty';

      }, cellColor: (row: BankTransferLoad) => {
        if (row.isExported) {
          return 'dodgerblue';
        }
        if ( row.isConfirmed) {
          return 'forestgreen';
        }

        return 'grey';

      } },
    {columnDef: 'exportStatus', header: '', cell: (row: BankTransferLoad) => `${row.isExported ? 'Exported' : 'Not exported'}`},



  ];

  customActions: AppMatCustomAction[] = [];

  ngOnInit() {
    this.rebuildCustomActions();
  }


  Edit(bankTransferLoad: BankTransferLoad) {
    this.router.navigate([bankTransferLoad.id, 'edit'], {relativeTo: this.route});
  }

  editEnabled() {
    return false;
  }

  deleteLoadsEnabled() {
    return false;
  }

  getRowClass = (item: BankTransferLoad): string => {
    const classes = [];
    if ( !item.isApprovedManually && item.needsManualApproval) {
      classes.push('needs-approval');
    }
    if ( item.riskLevel == 2) {
      classes.push('risk-medium');
    }
    if ( item.riskLevel == 3) {
      classes.push('risk-high');
    }
    if ( item.riskLevel == 99) {
      classes.push('risk-unknown');
    }
    return classes.join(' ');
  };

  getViewLink = (item: BankTransferLoad): string => '/loads/btl/' + item.id;

  View(bankTransferLoad: BankTransferLoad) {
    this.router.navigate([bankTransferLoad.id], {relativeTo: this.route});
  }

  getEditLink = (item: BankTransferLoad): string => item.id.toString() + '/edit';

  returnBack() {
    // this.location.back();
    this.router.navigate(['/loads/btl'], {relativeTo: this.route});
  }


  refundLoads(rows: BankTransferLoad[]) {
    this.bankTransferRefundService.refundLoads(rows.map(row => row.id))
      .subscribe(result => {
          this.refreshDataSource();
          this.showMessage('selected loads marked as refunded');
},
        err => {
          this.showMessage(err.error.message || err.error || err.message);
          this.showError(err.error.message || err.error || err.message);
        });
  }

  holdLoads(rows: BankTransferLoad[]) {
    this.bankTransferLoadService.holdLoads(rows.map(row => row.id))
      .subscribe(result => {
          this.refreshDataSource();
          this.showMessage('selected loads resetted to "Hold"');
},
        err => {
          this.showMessage(err.error.message || err.error || err.message);
          this.showError(err.error.message || err.error || err.message);
        });
  }

  markLoadRefunded(row: BankTransferLoad) {
    this.bankTransferRefundService.refundLoad(row.id)
      .subscribe(result => {
          this.refreshDataSource();
          this.showMessage('load marked as refunded');
},
        err => {
          this.showMessage(err.error.message || err.error || err.message);
          this.showError(err.error.message || err.error || err.message);
        });
  }


  rebuildCustomActions() {

    if (this.roleService.hasRoles('admin')) {
      this.customActions = [
        new AppMatCustomAction('attach_money', 'refund selected loads', true, (rows: BankTransferLoad[]) => {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'Refund',
              text: 'Are you sure you want to refund the selected loads?'
            },
            minWidth: 350,
          })
            .afterClosed()
            .subscribe(result => {
              if (result == 'ok') {
                this.refundLoads(rows);
              }
            });
        }),
        new AppMatCustomAction('pause_circle_outline', 'set selected loads on hold', true, (rows: BankTransferLoad[]) => {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'On Hold',
              text: 'Are you sure you want to reset the selected loads to "Hold"?'
            },
            minWidth: 350,
          })
            .afterClosed()
            .subscribe(result => {
              if (result == 'ok') {
                this.holdLoads(rows);
              }
            });
        }),
        new AppMatCustomAction('attach_money', 'refund load', false, (row: BankTransferLoad) => {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'Refund',
              text: 'Are you sure you want to refund this load?'
            },
            minWidth: 350,
          })
            .afterClosed()
            .subscribe(result => {
              if (result == 'ok') {
                this.markLoadRefunded(row);
              }
            });
        }),
        new AppMatCustomAction('pause_circle_outline', 'set load on hold', false, (row: BankTransferLoad) => {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'On Hold',
              text: 'Are you sure you want to reset this load to "Hold"?'
            },
            minWidth: 350,
          })
            .afterClosed()
            .subscribe(result => {
              if (result == 'ok') {
                this.holdLoads([row]);
              }
            });
        }),

      ];
    }
  }

  refreshDataSource() {
    this.dataSource.loadData();
    this.table.refreshTable();
  }

  showMessage(message) {
    this.snackBar.open(message, null, {
      duration: 5000,
      panelClass: ['app-mat-snack-bar']
    });
    this._toastService.info(message);

  }

  showError(message) {
    this._toastService.error(message);
  }


  goToRefundHistory() {
    this.router.navigate(['../history'], {relativeTo: this.route});
  }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }
  currentUserIsFinanceManager(): boolean {
    return this.roleService.hasRoles('finance_manager');
  }
}
